import {
  queryCommissionLevel,
  updateCommissionLevel,
  queryDefaultPriceRule,
  optDefaultPriceRule,
  updateSinglePrice,
  queryItemPricePageList,
  queryPriceRulePageList,
  queryPriceRuleDetail,
  queryDistributorCompanyList,
  queryList,
  queryListAll,
  optItemRule,
  queryItemRulePageList,
  queryItemDetail,
  queryBrandListAll,
  editSellingPrice,
  exportDistributorPrice,
  exportExcelDistributorPrice,
  progressDistributorPrice,
  optPriceRule,
  batchUpdatePrice,
  batchUpdateCommission,
  batchCancelDefDiscount,
  batchCancelCommissionDefDiscount,
  batchPriceCancel,
  updateSingleCommission,
  queryDmsCompanyInfo,
  saveDmsSetting,
  queryTradeConfig,
  saveTradeConfig,
  getAutoImportItemsToKmt,
  updateAutoImportItemsToKmt,
  // verifyImg,
  gainIdentifyCode,
  checkIdentifyCode,
  saveCompanyInfo,
  queryPropertyClassify,
  getCatList,
  getKdzsShareUrl,
  updateSupplierInfo,
  updateAutoAppointInsteadShop,
  queryPostItemPricePageList,
  premiumDistributorPrice,
  reqDisDmsGoodsPrice
} from '@api/supplier/erpIndex.js';
import { getAllSellerCat } from '@api/supplier/index.js';


// 查询佣金规则
export const getCommissionLevel = () => {
  return queryCommissionLevel().then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}
// 保存佣金规则
export const saveCommission = (data) => {
  return updateCommissionLevel(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getDefaultPriceRule = () => {
    return queryDefaultPriceRule().then(res => {
        if(res.result == 1) {
          return res.data
        }
        return false
    })
}

export const getOptDefaultPriceRule = (data) => {
  return optDefaultPriceRule(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getUpdateSinglePrice = (data) => {
  return updateSinglePrice(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getBatchUpdatePrice = (data) => {
  return batchUpdatePrice(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getBatchUpdateCommission = (data) => { 
  return batchUpdateCommission(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getBatchCancelDefDiscount = (data) => { 
  return batchCancelDefDiscount(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getBatchCancelCommissionDefDiscount = (data) => { 
  return batchCancelCommissionDefDiscount(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const batchUpdatePriceCancel = (data) => {
  return batchPriceCancel(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}
// 修改佣金
export const changeSingleCommission = (data) => {
  return updateSingleCommission(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

// 0 ERP商品 1 分销小店商品
export const getItemPricePageList = (data, type = 0) => {
  const reqList = type === 0 ? queryItemPricePageList : reqDisDmsGoodsPrice;
  return reqList(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}
export const postItemPricePageList = (data) => {
  return queryPostItemPricePageList(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}
export const getPriceRulePageList = (data) => {
  return queryPriceRulePageList(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getOptPriceRule = (data) => {
  return optPriceRule(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getPriceRuleDetail = (data) => {
  return queryPriceRuleDetail(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

/**
 * 高级分销价展示设置
 * @param {*} data 
 * @param {*} params 
 * @returns 
 */
export const shopPremiumDistributorPrice = (data) => {
  return premiumDistributorPrice(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getDistributorCompanyList = (data) => {
  return queryDistributorCompanyList(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getList = (data) => {
  return queryList(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getListAll = (data) => {
  return queryListAll(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getOptItemRule = (data) => {
  return optItemRule(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}
// 查询是否开启自动导入商品到快麦通配置
export const getAutoImportItems = (data) => {
  return getAutoImportItemsToKmt(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}
// 查询是否开启自动导入商品到快麦通配置
export const updateAutoImportItems = (data) => {
  return updateAutoImportItemsToKmt(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getItemRulePageList = (data) => {
  return queryItemRulePageList(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getItemDetail = (data) => {
  return queryItemDetail(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getBrandListAll = (data, params) => {
  return queryBrandListAll(data, params).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getPropertyClassify = (data, params) => {
  return queryPropertyClassify(data, params).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

// 去除叶子分类节点的children属性
function formatCatList(list) {
  list.map(item => {
      if (item.children && item.children.length > 0) {
          item.children = formatCatList(item.children);
      } else {
          delete item['children'];
      }
      return item;
  });
  return list;
}

export const getCatData = (data, params) => {
  return getCatList(data, params).then(res => {
      if(res.result == 1) {
        const resData = res.data[0] || {};
        const { subIds = [], sellerCats = {} } = resData;
        let list = [], catNameMap = {};
        subIds.map(catId => {
            if (!catId.includes('_') && sellerCats[catId]) {
                list.push(sellerCats[catId]);
            }

            // 生成分类名字map
            const cid = catId.split('_').pop();
            catNameMap[cid] = sellerCats[catId]?.name ?? '';
        });
        list = formatCatList(list);
        return {
            originData: resData,
            catList: list,
            catNameMap,
        }
      }
      return false
  })
}

export const getAllCatData = (data, params) => {
  return getAllSellerCat(data, params).then(res => {
      if(res.result == 1) {
        const resData = res.data.length && res.data[0] || {};
        const { subIds = [], sellerCats = {} } = resData;
        let list = [], catNameMap = {};
        subIds.map(catId => {
            if (!catId.includes('_') && sellerCats[catId]) {
                list.push(sellerCats[catId]);
            }

            // 生成分类名字map
            const cid = catId.split('_').pop();
            catNameMap[cid] = sellerCats[catId]?.name ?? '';
        });
        return {
            originData: resData,
            catList: list,
            catNameMap,
        }
      }
      return false
  })
}


export const getEditSellingPrice = (data) => {
  return editSellingPrice(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getExportDistributorPrice = (data) => {
  return exportDistributorPrice(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getExportExcelDistributorPrice = (data) => {
  return exportExcelDistributorPrice(data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getProgressDistributorPrice = (url='',data) => {
  return progressDistributorPrice(url,data).then(res => {
      if(res.result == 1) {
        return res.data
      }
      return false
  })
}

export const getDmsCompanyInfo = (data) => {
  return queryDmsCompanyInfo(data).then(res => {
      if(res.result == 1) {
        return res.data || {}
      }
      return false
  })
}

export const saveDmsBaseSetting = (data) => {
  return saveDmsSetting(data).then(res => {
      if(res.result == 1) {
        return true
      }
      return false
  })
}

export const getTradeConfig = () => {
  return queryTradeConfig().then(res => {
    const configs = {};
    (res.data || []).forEach(({ configKey, configValue }) => {
      try {
        configs[configKey] = typeof configValue === 'string' ? JSON.parse(configValue) : configValue;
      } catch {
        configs[configKey] = configValue;
      }
    });
    return configs;
  });
}

export const setTradeConfig = (data) => {
  return saveTradeConfig(data).then(({data: { status }}) => {
    if (status === 'success') {
      return true;
    } else {
      return false;
    }
  })
}

export const getVerifyImg = (data) => {
  return verifyImg(data).then(res => {
      if(res.result == 1) {
        return true
      }
      return false
  })
}
export const getGainIdentifyCode = (data) => {
  return gainIdentifyCode(data).then(res => {
      if(res.result == 1) {
        return res
      }
      return false
  })
}

export const getCheckIdentifyCode = (data) => {
  return checkIdentifyCode(data).then(res => {
      if(res.result == 1) {
        return res
      }
      return false
  })
}

//保存手机号
export const saveCompanPhone = (data) => {
  return saveCompanyInfo(data).then(res => {
      if(res.result == 1) {
        return res
      }
      return false
  })
}

export const kdzsShareUrl = (data) => {
  return getKdzsShareUrl(data).then(res => {
    if(res.result == 1) {
      return res
    }
    return false
})
}
// 修改代发店铺
export const updateDfShop = (data) => {
  return updateSupplierInfo(data).then(res => {
      if(res.result == 1) {
        return res
      }
      return false
  })
}
//设置新授权的店铺默认勾选
export const shopDefaultSet = (data) => {
  return updateAutoAppointInsteadShop(data).then(res => {
      if(res.result == 1) {
        return res
      }
      return false
  })
}






